import { useMemo } from "react";
import type { PeopleSource } from "@playbookai/types";
import { createShellTenantPeopleSource } from "../api/tenant-people-source.js";
import { useAuthStore } from "../auth/auth-store.js";

/**
 * The default tenant `PeopleSource` for the signed-in person. One object per
 * person and tenant: a person field caches its search per source, so a source
 * rebuilt on every render would search again on every render, and one kept
 * across a tenant change could show the last tenant's cached people.
 */
export function useTenantPeopleSource(): PeopleSource {
  const userId = useAuthStore((state) => state.claims?.userId);
  const tenantId = useAuthStore((state) => state.claims?.tenantId);
  // `tenantId` is not read by the factory: it only ends the source's lifetime.
  return useMemo(
    () => createShellTenantPeopleSource(userId),
    [userId, tenantId],
  );
}
